export default __webpack_public_path__ + "static/media/KZ.T.13.E0493 black.553ebfec.svg";